import { shiftMonth } from '../comercial360/com360Shared';

export { API_URL } from '../comercial360/com360Shared';

export const CATEGORY_LABEL = {
  luz_gas: 'Luz / Gás', energias: 'Energia', solar: 'Solar', carregamento: 'Carregamento',
  telecomunicacoes: 'Telecomunicações', alarmes: 'Alarmes',
};

const lastDay = (ym) => {
  const n = shiftMonth(ym, 1);
  const d = new Date(parseInt(n.slice(0, 4), 10), parseInt(n.slice(5, 7), 10) - 1, 0);
  return `${ym}-${String(d.getDate()).padStart(2, '0')}`;
};

export const listUrl = ({ category, company, month, status, proprietario }) => {
  const p = new URLSearchParams();
  if (month) { p.set('date_from', `${month}-01`); p.set('date_to', lastDay(month)); }
  if (status) p.set('status', status);
  if (proprietario) p.set('proprietario', proprietario);
  return `/contracts/${category || 'luz_gas'}/${company}?${p.toString()}`;
};
